/**
 * file to store eventually global utils/data/functs useful to the WebApp
 */
const pageInfo = {
    1:{
      title:"Contact Details",
      subtitle:"Welcome to United Properties, we are glad to see you! Let’s get started by letting us know a little bit about you", 
      cit:"We care about your time, that's why we created a 3-stage onboarding that will not take more than 5 minutes to complete", 
      name:"William Mac",
      role:"CO-FOUNDER, INVESTOR"},
    2:{
      title:"Investment plans",
      subtitle:"Let us know about your investment plans. This will help us get you to the right expert who will help you further", 
      cit:"Save from thousands to millions on your deal. Secure the best possible. And get independent, unbiased advice for free",
      name:"Jodie Sears",
      role:"UNITED PROPERTIES' AGENT"},
    3:{
      title:"Investment details",
      subtitle:"This will help us figure out what your investment options are so that we can show you only possibly intresting for you deals",
      cit:"United Properties is about fast & easy searching, buying, selling and investing ever — online, with an expert by our side",
      name:"Ollie Mcmahon",
      role:"MANAGING DIRECTOR"}
  }
  const checkList = ["Single Family","Residential Multifamily","Commercial Retail","Commercial Industrial",
  "Commercial Hospitality","Commercial Warehousing","Commercial Office","Other"];

export { pageInfo,checkList };